import { invariant } from '@e-socna/utils';

import { MissionContextStatus } from '../types/mission-context.type';

import { useMissionContext } from './useMissionContext.hook';

export const useMissionReadyContext = () => {
  const context = useMissionContext();

  invariant(
    context.status === MissionContextStatus.Ready,
    'useMissionReadyContext requires MissionContext to be ready',
  );

  return context;
};
